module.exports = "//d274d294w9cx2v.cloudfront.net/3f252560c3bf5e8ca1cf5366a439ca6fa4436613/images/photo-single.png";